import type { AdminCaseImageUploadedBy, AiReviewSummary } from '../api/cases';

const SOURCE_LABELS: Record<string, string> = {
  admin_case_triage: 'Admin case triage',
};

/**
 * Best-available uploader label: human display name → friendly source
 * label → uploading product → Unknown. Historical partner uploads carry
 * only client/product identity, so the product fallback is common.
 */
export function uploaderLabel(u: AdminCaseImageUploadedBy | null | undefined): string {
  if (!u) return 'Unknown';
  if (u.display_name) return u.display_name;
  if (u.source) return SOURCE_LABELS[u.source] ?? u.source;
  if (u.product_name) return `via ${u.product_name} API`;
  return 'Unknown';
}

/** Reviews (any status, "any review" semantics per spec) that submitted this image to DERM. */
export function reviewsUsingImage(reviews: AiReviewSummary[], imageId: string): AiReviewSummary[] {
  return reviews.filter((r) => (r.images ?? []).some((ri) => ri.clinicalImageId === imageId));
}
